import React from 'react'
import WomenImage from '../../../assets/images/signupImage.png'

export const Image = () => {
  return (
    <>
    <img src={WomenImage} alt="GirlImage is not display in Signup Page" width="500px" height="550px"/>
    </>
  )
}

export default Image